<template>
  <div class="nav-step">
    <div :class="['icons', state]">
      <i :class="['point', pointerClass]" @click="exportPosition"></i>
      <span class="line"></span>
    </div>
    <div :class="['details', state]" @click="exportPosition">
      <div class="nav-title">
        {{ title }}
      </div>
      <div class="nav-subtitle" v-text="subtitle"></div>
    </div>
  </div>
</template>

<script lang="js">
  import { NAVIGATOR_STATE } from '@/common/consts';
  import { currentThemeMixin } from '@/mixins';

  export default {
    name: 'ihu-nav-step',
    mixins: [currentThemeMixin],
    props: {
      state: {
        type: String,
        default: null,
      },
      title: {
        type: String,
        default: '',
      },
      subtitle: {
        type: String,
        default: '',
      },
    },
    computed: {
      pointerClass() {
        let icon = `ico-nav-item-${this.currentTheme}`;
        if (this.state && this.state !== NAVIGATOR_STATE.NONE) {
          icon = `${icon}-${this.state}`;
        }
        return icon;
      },
    },
    methods: {
      exportPosition() {
        if (this.state !== NAVIGATOR_STATE.ACTIVE && this.state !== NAVIGATOR_STATE.NONE) {
          this.$emit('setStep');
        }
      },
    },
  };
</script>

<style scoped lang="scss">
.nav-step {
  display: flex;
  flex-direction: row;
  align-content: stretch;

  .icons {
    display: flex;
    flex-direction: column;
    align-content: stretch;
    align-items: center;

    .point {
      width: 24px;
      height: 35px;
    }

    .line {
      height: 100%;
      width: 2px;
      @include themify {
        background: getColor('medallia-nav-line', 'ihu');
      }
    }

    &.done {
      cursor: pointer;

      .line {
        @include themify {
          background: getColor('medallia-nav-line-active', 'ihu');
        }
      }
    }
    &.active {
      cursor: pointer;
    }
  }

  &:last-child {
    .line {
      background: none !important;
    }
  }

  .details {
    padding: 0 12px 28px;

    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 11.67px;
    line-height: 150%;
    @include themify {
      color: getColor('medallia-nav-color', 'ihu')
    }

    .nav-title {
      font-weight: 500;
      font-size: 14px;
      line-height: 120%;

      display: flex;
      justify-content: flex-start;
      margin: 4px 0;
      text-align: start;

      @include themify {
        color: getColor('medallia-nav-title', 'ihu')
      }
    }

    .nav-subtitle {
      text-align: left;
      display: flex;
      justify-content: flex-start;
      min-height: 50px;
    }

    &.done, &.active {
      cursor: pointer;

      .nav-title {
        @include themify {
          color: getColor('medallia-nav-title-active', 'ihu')
        }
      }
    }
  }
}
</style>

